export const AUTH_PROFILE_STORAGE_KEY = 'authProfile';
export const AUTH_NOTICE_STORAGE_KEY = 'authNotice';

const LOGIN_PATH = '/login';
const DEFAULT_POST_LOGIN_PATH = '/dashboard';
const AUTH_REDIRECT_QUERY_PARAM = 'redirect';

const sanitizeAuthRedirectPath = (value = '') => {
  const normalized = String(value || '').trim();
  if (!normalized.startsWith('/')) return '';
  if (normalized.startsWith('//')) return '';
  return normalized;
};

const buildCurrentBrowserPath = () => {
  if (typeof window === 'undefined') return '';
  return sanitizeAuthRedirectPath(
    `${window.location.pathname || ''}${window.location.search || ''}${window.location.hash || ''}`
  );
};

export function readStoredAuthProfile() {
  try {
    const parsed = JSON.parse(localStorage.getItem(AUTH_PROFILE_STORAGE_KEY) || 'null');
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (_error) {
    return null;
  }
}

export function clearStoredAuthSession() {
  localStorage.removeItem('token');
  localStorage.removeItem(AUTH_PROFILE_STORAGE_KEY);
}

export function setAuthNotice(message = '') {
  if (!message) {
    sessionStorage.removeItem(AUTH_NOTICE_STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(AUTH_NOTICE_STORAGE_KEY, message);
}

export function consumeAuthNotice() {
  const message = sessionStorage.getItem(AUTH_NOTICE_STORAGE_KEY) || '';
  if (message) {
    sessionStorage.removeItem(AUTH_NOTICE_STORAGE_KEY);
  }
  return message;
}

export function buildLoginRedirectPath(redirectPath = '') {
  const safeRedirectPath = sanitizeAuthRedirectPath(redirectPath);
  if (!safeRedirectPath || safeRedirectPath === LOGIN_PATH) {
    return LOGIN_PATH;
  }

  return `${LOGIN_PATH}?${AUTH_REDIRECT_QUERY_PARAM}=${encodeURIComponent(safeRedirectPath)}`;
}

export function resolvePostLoginRedirect({ search = '', stateFrom = null } = {}) {
  const fromStatePath = sanitizeAuthRedirectPath(
    stateFrom && typeof stateFrom === 'object'
      ? `${stateFrom.pathname || ''}${stateFrom.search || ''}${stateFrom.hash || ''}`
      : ''
  );
  if (fromStatePath && fromStatePath !== LOGIN_PATH) {
    return fromStatePath;
  }

  const params = new URLSearchParams(search || '');
  const fromQueryPath = sanitizeAuthRedirectPath(params.get(AUTH_REDIRECT_QUERY_PARAM) || '');
  if (fromQueryPath && fromQueryPath !== LOGIN_PATH) {
    return fromQueryPath;
  }

  return DEFAULT_POST_LOGIN_PATH;
}

export function logoutAndRedirect({ message = '', redirectToLogin = true, redirectPath = '' } = {}) {
  clearStoredAuthSession();
  setAuthNotice(message);

  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent('auth-logout', { detail: { message } }));

  if (!redirectToLogin) return;
  if (window.location.pathname === LOGIN_PATH) return;

  const nextRedirectPath = sanitizeAuthRedirectPath(redirectPath) || buildCurrentBrowserPath();
  window.location.replace(buildLoginRedirectPath(nextRedirectPath));
}
